var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "drag-tool",
      class: { active: _vm.state.active === _vm.id },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.active($event)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "drag-l" },
        [
          _c(
            "el-tooltip",
            { attrs: { effect: "dark", content: "拖拽", placement: "top" } },
            [
              _vm.state.active === _vm.id && _vm.dragBtn !== false
                ? _c(
                    "div",
                    {
                      staticClass: "drag-btn _fc-drag-btn",
                      staticStyle: { cursor: "move" },
                    },
                    [_c("i", { staticClass: "iconfont icontuozhuai" })]
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "drag-r" },
        [
          _c(
            "el-tooltip",
            { attrs: { effect: "dark", content: "添加", placement: "top" } },
            [
              _vm.typeList.indexOf(_vm.type) == -1
                ? _c(
                    "div",
                    {
                      staticClass: "drag-btn",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("add")
                        },
                      },
                    },
                    [_c("i", { staticClass: "iconfont icontianjia1" })]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-tooltip",
            { attrs: { effect: "dark", content: "复制", placement: "top" } },
            [
              _vm.typeList.indexOf(_vm.type) == -1
                ? _c(
                    "div",
                    {
                      staticClass: "drag-btn",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("copy")
                        },
                      },
                    },
                    [_c("i", { staticClass: "iconfont iconfuzhi1" })]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.children
            ? _c(
                "div",
                {
                  staticClass: "drag-btn",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("addChild")
                    },
                  },
                },
                [_c("i", { staticClass: "fc-icon icon-add-child" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-tooltip",
            { attrs: { effect: "dark", content: "删除", placement: "top" } },
            [
              _c(
                "div",
                {
                  staticClass: "drag-btn drag-btn-danger",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("delete")
                    },
                  },
                },
                [_c("i", { staticClass: "iconfont iconshanchu1" })]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "drag-mask" }),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }